import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { teamsApi } from '../services/api';
import { getPlayer, setPlayer } from '../utils/playerStorage';

export default function SelectPlayerPage() {
  const [teams, setTeams] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    if (getPlayer()) {
      navigate('/map', { replace: true });
      return;
    }

    teamsApi.getAll()
      .then(res => setTeams(res.data))
      .catch(err => console.error('Failed to load teams:', err))
      .finally(() => setLoading(false));
  }, [navigate]);

  const selectPlayer = (player, team) => {
    setPlayer({
      playerId: player.id,
      playerName: player.name,
      teamId: team.id,
      teamName: team.name,
    });
    navigate('/map');
  };

  if (loading) {
    return (
      <div className="page loading-page">
        <div className="spinner" />
      </div>
    );
  }

  return (
    <div className="page select-page">
      <div className="select-header">
        <h1>Reykjavík Rebus</h1>
        <p className="subtitle">Velg hvem du er</p>
      </div>

      <div className="teams-list">
        {teams.map(team => (
          <div key={team.id} className="team-group">
            <h2 className="team-name">{team.name}</h2>
            <div className="players-grid">
              {team.players.map(player => (
                <button
                  key={player.id}
                  className="player-btn"
                  onClick={() => selectPlayer(player, team)}
                >
                  <span className="player-initial">{player.name.charAt(0)}</span>
                  <span className="player-name">{player.name}</span>
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
